import StatisticalMethodsExplanation from './StatisticalMethodsExplanation/index';

export default StatisticalMethodsExplanation; 